export enum BtnTypeEnum {
    "DISABLED",
    "DEPOSITE",
    "CANCLAIM",
    "CLAIMED",
}

export const BtnTypeMap = new Map<BtnTypeEnum, string>([
    [BtnTypeEnum.DISABLED, "Recompensa Recebida"],
    [BtnTypeEnum.DEPOSITE, "Recarregar"],
    [BtnTypeEnum.CANCLAIM, "Receber Recompensa"],
]);

// 进行中running、待领取pending、已领取received、已过期expired

export enum CashbackStatusEnum {
    "RUNNING" = "running",
    "PENDING" = "pending",
    "RECEIVED" = "received",
    "EXPIRED" = "expired",
}

export const CashbackStatusMap = new Map<CashbackStatusEnum, string>([
    [CashbackStatusEnum.RUNNING, "cashback.goGame"],
    [CashbackStatusEnum.PENDING, "cashback.receiveButton"],
    [CashbackStatusEnum.RECEIVED, "cashback.goGame"],
    [CashbackStatusEnum.EXPIRED, "cashback.goGame"],
]);

export const ClaimActiveErrorMap = new Map<number, string>([
    [1022, "Restrição anormal de conta"],
    [6002, "Nenhum bônus não pode ser reclamado no modo bônus ativado"],
    [6001, "As condições do bônus de esvaziamento não são atendidas"],
]);

export enum FundsHandleType {
    DEPOSITE = 1,
    WITHDRAW = 2,
}
export const FundsHandleTypeMap = new Map<FundsHandleType, Record<string, string>>([
    [
        FundsHandleType.DEPOSITE,
        {
            text: "Depósito",
            descTitle: "Depósito",
        },
    ],
    [
        FundsHandleType.WITHDRAW,
        {
            text: "Sacar",
            descTitle: "Regras de saque",
        },
    ],
]);

export enum ChannelEnum {
    CPF = 1,
    Email = 2,
    Phone = 3,
    CNPJ = 4,
}

export const ChannelEnumMap = new Map<ChannelEnum, Record<string, string>>([
    [
        ChannelEnum.CPF,
        {
            placeholder: "Seu CPF(000.000.000-00)",
            text: "CPF ID",
        },
    ],
    [
        ChannelEnum.Email,
        {
            text: "Email",
            placeholder: "Email",
        },
    ],
    [
        ChannelEnum.Phone,
        {
            text: "Phone",
            placeholder: "11 dígitos",
        },
    ],
    [
        ChannelEnum.CNPJ,
        {
            text: "CNPJ",
            placeholder: "CNPJ(00.000.000.0000-00)",
        },
    ],
]);

export enum GameListTypeEnum {
    PROVIDER = "provider_id",
    TAG = "tag_id",
    DEFAULT = "",
}

export const HeaderImageMap = new Map<number, Record<string, any>>([
    [
        1,
        {
            img: "/user_header/h_1.webp",
        },
    ],
    [
        2,
        {
            img: "/user_header/h_2.webp",
        },
    ],
    [
        3,
        {
            img: "/user_header/h_3.webp",
        },
    ],
    [
        4,
        {
            img: "/user_header/h_4.webp",
        },
    ],
    [
        5,
        {
            img: "/user_header/h_5.webp",
        },
    ],
    [
        6,
        {
            img: "/user_header/h_6.webp",
        },
    ],
    [
        7,
        {
            img: "/user_header/h_7.webp",
        },
    ],
    [
        8,
        {
            img: "/user_header/h_8.webp",
        },
    ],
]);

export enum VipRewardTypeEnum {
    "Level" = 1,
    "DAY" = 2,
    "WEEK" = 3,
    "MONTH" = 4,
    "FIRST" = 5,
    "SECOND" = 6,
}

export const VipRewardTypeMap = new Map<VipRewardTypeEnum, Record<string, string | number>>([
    [
        VipRewardTypeEnum.Level,
        {
            openKey: "is_level_up_reward",
        },
    ],
    [
        VipRewardTypeEnum.DAY,
        {
            openKey: "is_daily_reward",
            doubleKey: "is_daily_double_reward",
            amountKey: "daily_reward_num",
            amountDoubleKey: "daily_reward_multiple_num",
        },
    ],
    [
        VipRewardTypeEnum.WEEK,
        {
            openKey: "is_weekly_reward",
            doubleKey: "is_weekly_double_reward",
            amountKey: "weekly_reward_num",
            amountDoubleKey: "weekly_reward_multiple_num",
        },
    ],
    [
        VipRewardTypeEnum.MONTH,
        {
            openKey: "is_monthly_reward",
            doubleKey: "is_monthly_double_reward",
            amountKey: "monthly_reward_num",
            amountDoubleKey: "monthly_reward_multiple_num",
        },
    ],
    [
        VipRewardTypeEnum.FIRST,
        {
            openKey: "is_first_bankruptcy",
            amountKey: "first_bankruptcy_reward_num",
        },
    ],
    [
        VipRewardTypeEnum.SECOND,
        {
            openKey: "is_second_bankruptcy",
            amountKey: "second_bankruptcy_reward_num",
        },
    ],
]);

export enum FeedbackStatusEnum {
    NONE = "none",
    RUNNING = "running",
}

export enum WrapHocPosition {
    top = "top",
    bottom = "bottom",
    center = "center",
    left = "left",
    right = "right",
}
export interface VipItem {
    text: string;
    icon: string;
    startColor?: string;
    endColor?: string;
}

export const VipProgressMap = new Map<number, VipItem>([
    [0, { text: "0", icon: "/vip/0.webp", startColor: "#2e2f36", endColor: "#727583" }],
    [1, { text: "1", icon: "/vip/1.webp", startColor: "#312d2a", endColor: "#8a8079" }],
    [2, { text: "2", icon: "/vip/2.webp", startColor: "#24292b", endColor: "#748389" }],
    [3, { text: "3", icon: "/vip/3.webp", startColor: "#28262d", endColor: "#7d788c" }],
    [4, { text: "4", icon: "/vip/4.webp", startColor: "#2e282b", endColor: "#83777e" }],
    [5, { text: "5", icon: "/vip/5.webp", startColor: "#25292c", endColor: "#6f7a80" }],
    [6, { text: "6", icon: "/vip/6.webp", startColor: "#282422", endColor: "#827972" }],
    [7, { text: "7", icon: "/vip/7.webp", startColor: "#231f25", endColor: "#7f7485" }],
    [8, { text: "8", icon: "/vip/8.webp", startColor: "#232b2d", endColor: "#748084" }],
    [9, { text: "9", icon: "/vip/9.webp", startColor: "#352d2f", endColor: "#89797d" }],
    [10, { text: "10", icon: "/vip/10.webp", startColor: "#25231f", endColor: "#8a847a" }],
    [11, { text: "11", icon: "/vip/11.webp", startColor: "#2c252c", endColor: "#837482" }],
    [12, { text: "12", icon: "/vip/12.webp", startColor: "#222025", endColor: "#756e7d" }],
    [13, { text: "13", icon: "/vip/13.webp", startColor: "#2a2527", endColor: "#81737a" }],
    [14, { text: "14", icon: "/vip/14.webp", startColor: "#2b2426", endColor: "#8f7f83" }],
    [15, { text: "15", icon: "/vip/15.webp", startColor: "#2f272d", endColor: "#877882" }],
    [16, { text: "16", icon: "/vip/16.webp", startColor: "#282126", endColor: "#7e7078" }],
    [17, { text: "17", icon: "/vip/17.webp", startColor: "#282321", endColor: "#867974" }],
    [18, { text: "18", icon: "/vip/18.webp", startColor: "#28252c", endColor: "#7b7384" }],
    [19, { text: "19", icon: "/vip/19.webp", startColor: "#28302b", endColor: "#74867a" }],
    [20, { text: "20", icon: "/vip/20.webp", startColor: "#22282c", endColor: "#737f87" }],
    [21, { text: "21", icon: "/vip/21.webp", startColor: "#29302f", endColor: "#677975" }],
    [22, { text: "22", icon: "/vip/22.webp", startColor: "#282323", endColor: "#807271" }],
    [23, { text: "23", icon: "/vip/23.webp", startColor: "#2e2626", endColor: "#806f6f" }],
    [24, { text: "24", icon: "/vip/24.webp", startColor: "#282222", endColor: "#867373" }],
    [25, { text: "25", icon: "/vip/25.webp", startColor: "#2c2931", endColor: "#787181" }],
    [26, { text: "26", icon: "/vip/26.webp", startColor: "#29242a", endColor: "#7f7181" }],
    [27, { text: "27", icon: "/vip/27.webp", startColor: "#2b2d33", endColor: "#747a87" }],
    [28, { text: "28", icon: "/vip/28.webp", startColor: "#262c26", endColor: "#727f72" }],
    [29, { text: "29", icon: "/vip/29.webp", startColor: "#322c2a", endColor: "#847874" }],
    [30, { text: "30", icon: "/vip/30.webp", startColor: "#322b2a", endColor: "#807371" }],
    [31, { text: "31", icon: "/vip/31.webp", startColor: "#2e2727", endColor: "#7e6f6f" }],
    [32, { text: "32", icon: "/vip/32.webp", startColor: "#342a2a", endColor: "#887373" }],
    [33, { text: "33", icon: "/vip/33.webp", startColor: "#2d2a25", endColor: "#958b7b" }],
]);
